module.exports = __webpack_public_path__ + "images/ic-tower_and_wxwork_2@2x-932c839a32675e629c2ccff316b75582.png";